var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalCellular2Bar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 19.9999H19.9999V6.82494L12.9999 13.8249V19.9999ZM4.42494 21.9999C3.97494 21.9999 3.66227 21.7956 3.48694 21.3869C3.31227 20.9789 3.38327 20.6166 3.69994 20.2999L20.2999 3.69994C20.6166 3.38327 20.9793 3.31227 21.3879 3.48694C21.7959 3.66227 21.9999 3.97494 21.9999 4.42494V20.9999C21.9999 21.2833 21.9039 21.5206 21.7119 21.7119C21.5206 21.9039 21.2833 21.9999 20.9999 21.9999H4.42494Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalCellular2Bar);
export default __webpack_public_path__ + "static/media/signal-cellular-2-bar.6bce091f2aa8b54e25c881c90d33a570.svg";
export { ForwardRef as ReactComponent };